import React, { useState, useRef } from "react";
import { saveAs } from "file-saver";
import { Button } from "react-bootstrap";
import { CreacionTitulosService } from "../../../../_services/creaciontitulos.service";
import NewProcessingModal from "../../../../components/LoadingModal/NewProcessingModal";
import XlsGeneratorTour from "../Tours/XlsGeneratorTour";

const XlsGeneratorHome = () => {
  const [file, setFile] = useState(null);
  const [category, setCategory] = useState("");
  const [modalStatus, setModalStatus] = useState({ status: null, message: "" }); // "processing", "success", o null
  const isSubmitDisabled = !file || !category;
  const fileInputRef = useRef(null);
  const [showTour, setShowTour] = useState(false);


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  const resetFileInput = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const restartStates = () => {
    setCategory("");
    resetFileInput();
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Por favor, selecciona un archivo.");
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    try {
      setModalStatus({ status: "processing", message: "Procesando excel" });
      const response = await CreacionTitulosService.postGenerateXLS(file, category);
      const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      setModalStatus({ status: "success", message: "Excel procesado con éxito" });
      saveAs(blob, `${file.name}_procesado.xlsx`);
      restartStates();
    } catch (error) {
      console.error("Error al enviar el archivo", error);
      setModalStatus({ status: "error", message: "Error al procesar el excel" });
      restartStates();
    }
  };

  const handleDownloadSLXBase = async () => {
    try {
      const response = await CreacionTitulosService.getXlsBase();
      const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      saveAs(blob, "ExcelBasicoCreacionTitulos.xlsx");
    } catch (error) {
      console.error("Error al enviar el archivo", error);
      alert("Error al enviar el archivo");
    }
  };

  return (
    <div className="mt-5 shadow-top">
      <div className="p-4 shadow">
        <div className="d-flex">

          <h5 className="fw-semibold mb-4 mr-5">Generador de Archivos XLS</h5>

          <button className="btn-paso-paso" onClick={() => setShowTour(true)}>
            Guía paso a paso
          </button>
        </div>

        <div
          id="selecciona-categoria"
          className="mb-3 d-flex flex-column">
          <label className="form-label mb-2">Selecciona una categoría:</label>
          <select
            className="custom-select"
            value={category}
            onChange={handleCategoryChange}
          >
            <option value="" disabled>Selecciona una opción</option>
            <option value="inmueble">Inmueble</option>
            <option value="comercio">Comercio</option>
          </select>
        </div>

        <div className="mb-3" id="subir-archivo">
          <label className="form-label mb-2">
            Selecciona un archivo:
          </label>

          <div className="custom-file-wrapper">
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="custom-file-input"
              id="fileUpload"
            />

            <label htmlFor="fileUpload" className="custom-file-button">
              Seleccionar
            </label>

            <span
              className={`custom-file-text ${!file ? "no-file" : ""}`}
            >
              {file ? file.name : "Ningún archivo seleccionado"}
            </span>
          </div>
        </div>

        <div >
          <Button
            id="enviar-archivo"
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
            className="mb-3"
          >
            Enviar archivo
          </Button>
        </div>

        <div className="border-top mb-3" />

        <div id="descarga-excel-base">
          <h5 className="mb-3 fw-semibold">Descarga Excel Básico</h5>
          <p className="mb-3">Para descargar el excel base para su llenado y luego procesamiento haga click en el siguiente botón</p>
          <div>
            <Button
              onClick={handleDownloadSLXBase}
              className="d-inline-flex align-items-center gap-2 btn-green fw-semibold"
            >
              Descargar Ejemplo Base
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 48 48" className="ml-2">
                <path fill="#169154" d="M29,6H15.744C14.781,6,14,6.781,14,7.744v7.259h15V6z"></path><path fill="#18482a" d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42H29v-8.946H14z"></path><path fill="#0c8045" d="M14 15.003H29V24.005000000000003H14z"></path><path fill="#17472a" d="M14 24.005H29V33.055H14z"></path><g><path fill="#29c27f" d="M42.256,6H29v9.003h15V7.744C44,6.781,43.219,6,42.256,6z"></path><path fill="#27663f" d="M29,33.054V42h13.257C43.219,42,44,41.219,44,40.257v-7.202H29z"></path><path fill="#19ac65" d="M29 15.003H44V24.005000000000003H29z"></path><path fill="#129652" d="M29 24.005H44V33.055H29z"></path></g><path fill="#0c7238" d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"></path><path fill="#fff" d="M9.807 19L12.193 19 14.129 22.754 16.175 19 18.404 19 15.333 24 18.474 29 16.123 29 14.013 25.07 11.912 29 9.526 29 12.719 23.982z"></path>
              </svg>
            </Button>
          </div>
        </div>
      </div>
      <NewProcessingModal status={modalStatus} onClose={() => setModalStatus({ status: undefined, message: "" })} />
      {showTour && (
        <XlsGeneratorTour
          onFinish={() => setShowTour(false)}
        />
      )}
    </div>
  );
};

export default XlsGeneratorHome;